export const ResultsEmpty = () => {
  return (
    <div
      id="risultati"
      className="ml-auto mr-auto w-full rounded-lg border-solid bg-white p-10 "
    >
      <div className="ml-auto mr-auto max-w-box">
        <h3 className="text-x text-primary font-bold md:text-2xl">
          Spiacenti nessun risultato trovato
        </h3>
      </div>
    </div>
  );
};
